var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    height: "1rem",
    width: "1rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.063,20.299c0,1.191-0.965,2.156-2.156,2.156H4.094c-1.191,0-2.156-0.965-2.156-2.156V4.487 c0-1.191,0.965-2.156,2.156-2.156h15.813c1.191,0,2.156,0.965,2.156,2.156V20.299z M13.08,5.206c-0.958,0-1.441,1.162-0.763,1.84 l1.437,1.437L4.97,17.267c-0.21,0.21-0.21,0.552,0,0.762l1.394,1.394c0.21,0.21,0.552,0.21,0.762,0l8.784-8.784l1.437,1.437 c0.675,0.675,1.84,0.201,1.84-0.762v-5.03c0-0.595-0.483-1.078-1.078-1.078H13.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/SeeMore.e0e2019c.svg";
export { ForwardRef as ReactComponent };